import type { Post } from '@/@types/post'
import { track } from '@ruguoapp/jk-analytics'
import { useInView } from 'motion/react'
import { type RefObject, useEffect } from 'react'

export default function usePostInViewTracker(data: Post, ref: RefObject<HTMLDivElement>) {
	const inView = useInView(ref, {
		once: true,
	})

	useEffect(() => {
		if (inView) {
			track('feed_content_view', {
				event_info: {
					event: 'feed_content_view',
				},
				content_info: {
					action: 'view',
					read_track_info: JSON.stringify(data.readTrackInfo),
					content_id: data.id,
					content_type: data.type,
				},
			})
		}
	}, [inView, data.id, data.type, data.readTrackInfo])
}
